import vue from 'vue'
import {
  getCity,
  getRoleList,
  getCompanyList,
  getUserList,
  uploadFile,
} from "@/services/common";


const state = {
  tableRow: vue.ls.get('tableRow'),
  cityTree: [],//省市区
  roleList: [],//角色list
  userList: [],//用户list
  companyList: [],//公司list
  noAccount: true,
  fileUrl: '',
  cropperVisible: false,
  identityCardFront: '',//身份证正面
  identityCardBehind: '',//身份证反面
  businessLicense: '',//营业执照
  authLetter: '',//认证公函
};

const getters = {
  tableRow: () => state.tableRow ? state.tableRow : vue.ls.get('tableRow'),
  cityTree: () => state.cityTree,
  roleList: () => state.roleList,
  userList: () => state.userList,
  companyList: () => state.companyList,
  fileUrl: () => state.fileUrl,
  cropperVisible: () => state.cropperVisible,
  identityCardFront: () => state.identityCardFront,
  identityCardBehind: () => state.identityCardBehind,
  businessLicense: () => state.businessLicense,
  authLetter: () => state.authLetter,
};

const actions = {
  //省市区
  getCity({commit}) {
    getCity().then((res) => {
      commit('updateState', {state: 'cityTree', update: res.data});
    })
  },
  //角色list
  getRoleList({commit, dispatch}, objc) {
    getRoleList().then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'roleList', update: res.data});
      }
    })
  },
  //用户list
  getUserList({commit, dispatch}, objc) {
    getUserList({size: 1000000, current: 1}).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'userList', update: res.data.records});
      }
    })
  },
  //公司list
  getCompanyList({commit, dispatch}, objc) {
    getCompanyList(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'companyList', update: res.data});
      }
    })
  },
  //上传文件
  uploadFile({commit, dispatch}, objc) {
    uploadFile(objc.params).then((res) => {
      //todo 文件上传成功之后做裁剪
      if (res.code == 0) {
        if (objc.title) {
          commit('updateState', {state: 'cropperVisible', update: false});
          commit('updateState', {state: objc.title, update: res.data});
        } else {
          commit('updateState', {state: 'cropperVisible', update: false});
          commit('updateState', {state: 'fileUrl', update: res.data});
        }
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'tableRow') {
      vue.ls.set(payload.state, payload.update);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/common/modules/common.js